export enum NetworkDeviceTypes {
  TABLET = 'Tablet',
  DEVICE = 'Device'
}
